/** 是否有指定收件人 */
export function receiverName(order: order) {
    if (order.receiverId && order.receiverName && order.receiverId.length !== 6) {
        return order.receiverName;
    } else {
        return null;
    }
}

type order = {
    receiverId: string | null,
    receiverName: string | null,
}
